import React, { useState } from "react";
import { classNames } from "src/helpers/classNames";

const FAQSection = ({ data }) => {
  const FaqItem = ({ data }) => {
    const [isFaqOpen, setFaqOpen] = useState(false);
    return (
      <>
        <div className="py-6 first:pt-0 last:pb-0">
          <dt>
            <button
              className="flex w-full items-start justify-between text-left text-slate-900"
              type="button"
              onClick={() => setFaqOpen(!isFaqOpen)}>
              <span className="text-lg font-semibold">{data?.question}</span>
              <span className="ml-6 flex h-7 items-center">
                {isFaqOpen ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    data-slot="icon"
                    className="h-8 w-8">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M18 12H6"></path>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    data-slot="icon"
                    className="h-8 w-8">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 6v12m6-6H6"></path>
                  </svg>
                )}
              </span>
            </button>
          </dt>
          {isFaqOpen && (
            <dd className="mt-2 pr-12">
              <div className="text-base text-slate-500">{data?.answer}</div>
            </dd>
          )}
        </div>
      </>
    );
  };

  return (
    <section className={classNames(data?.hidden ? "hidden" : "relative mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40")}>
      <div className="mx-auto max-w-4xl">
        <h2 className="text-4xl font-semibold tracking-tight text-blue-950 sm:text-5xl sm:leading-tight">{data?.title}</h2>
        {data?.faqs?.length > 0 && (
          <dl className="mt-16 divide-y divide-gray-900/10">
            {data?.faqs?.map((item, index) => (
              <FaqItem
                key={index}
                data={item}
              />
            ))}
          </dl>
        )}
      </div>
    </section>
  );
};

export default FAQSection;
